import styled from 'styled-components';

export const IndexContainer = styled.div`
    overflow: scroll;
    height: 100vh;
    scroll-snap-type: y mandatory;
`;